<template>

    <div class="modal" v-bind:class="{ 'is-active' : isModalActive}">
        <div class="modal-background" @click="toggleModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Atención</p>
                <button class="delete" aria-label="close" @click="toggleModal"></button>
            </header>
            <section class="modal-card-body">
                {{modalText}}
            </section>
            <!--<footer class="modal-card-foot">-->
                <!--<button class="button is-dark" @click="toggleModal">Accept</button>-->
            <!--</footer>-->
        </div>
    </div>

</template>

<script>

export default {

  data () {
    return {
      showModal: false,
      modalText: ''
    }
  },

  created () {
    Event.$on('showModal', message => {
      this.showModal = true
      this.modalText = message || this.modalText
    })
  },

  computed: {
    isModalActive () {
      return this.showModal
    }
  },

  methods: {

    toggleModal () {
      this.showModal = !this.showModal
    }
  }
}
</script>

<style scoped>
    header.modal-card-head {
        background-image: linear-gradient(141deg, #1f191a 0%, #363636 71%, #46403f 100%);
        color: whitesmoke !important;
    }

    p.modal-card-title {
        color: whitesmoke;
    }

    header.modal-card-head {
        border: none;
        border-top-left-radius: 26px;
        border-top-right-radius: 26px;
    }

    section.modal-card-body {
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        padding-bottom: 6em;
    }

    button.delete {
        min-height: 40px;
        min-width: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/Modal.vue